import SupportLayout from '@/layout/supportLayout/SupportLayout';

export default SupportLayout;
